import { createPost } from "blog/post"
import { NodeKind } from "blog/json_nodes"
import { createExternalLink } from "blog/components/link"

export const GetACat = createPost({
  kind: NodeKind.POST,
  tags: ["cat", "principles and guidance"],
  title: "Get a cat",
  date: "2020-07-29T:21:45:00.0000Z",
  content: `
    <h1>You should get a Cat</h1>
    <h2>Backstory</h2>
    <p>
      We had just spent months avoiding going outside because of the destructive bushfires and choking smoke around Sydney, then we went into Coronavirus lock down.
      A couple weeks into quarantine I suggested we get a pet. The only worthwhile pets are mammals and the only worthwhile mammals in an apartment are mice, rats, and cats.
    </p>
    <p>
      I like mice and rats. They're intelligent, loving, low-cost, and incredibly cute. Hamsters and the like are just rats for cowards.
      I dislike cats, I disliked them when we got our cat and I'll continue to dislike them for the foreseeable future. They're no way near as clever, cost more, and a lot of them look damn dopey.
    </p>
    <p>
      We adopted our cat on May 20, 2020. He's clever, still-costs-more-than-rats-but-it-doesn't-matter, and damn cute (although he is damn dopey even if he doesn't look it).
    </p>
    <h2>Cats are convenient, lovable friends</h2>
    <h3>They live</h3>
    <p>
      Our cat (named little-guy, aka Chairman Meow, aka Mr Meowgi, aka Puss-In-Socks, aka Arturo, documented-name Leroy) is delighted to spend time on his own, we've been able to comfortably leave him on his own all-day. Cleaning litter and providing food are brief chores, and he keeps himself clean.
    </p>
    <h3>They love</h3>
    <p>
      He's quick on the uptake, fairly easy to train and unmistakeably loving (don't believe the gamer-chair-philosophers that would have you believe cats are empathy-void robots).
    </p>
    <h3>They laugh</h3>
    <img src="https://i.redd.it/styjkazch08y.jpg" class="thumbnail pull-right" />
    <p>
      From the moment we adopted him - in the car ride home - we've both been happier and more relaxed. The extra costs are minimal, less than $20 per week and we have not been cheaping out. The maintenance is minimal - get the right litter/litter tray and you have almost no problems.
    </p>
    <h3>They learn</h3>
    <p>
      He loves lamb and with the help of some tasty unskewered-kebabs has learned six tricks quite easily. In chronological order: speak, sit, come, up, jump, paw (aka shake). With hindsight I'd guess you could get through a new trick at least every 2nd week (if not every week) with enough care and consistency.
    </p>
    <h3>They listen</h3>
    <p>
      He has been my rubber ducky while I work, my consoler when I'm not feeling great, my harasser when I don't play rough with him, and a highly effective fly-swatter when bugs invade. More importantly he's scared the pigeons that used to shit on our balcony away.
    </p>
    <h3>They l..replicate</h3>
    <p>
      He's made me want to get a 2nd cat, both for his sake and my own. Get a cat. You'll be better for it, even if you dislike them.
    </p>
    <h2>Cats will (probably) improve your life</h2>
    <p>
      Everyone knows pet owners are healthier, happier and less stressed than their loser opposites - sorry pet un-owners - but did you know they are also way cooler. However, the reported health benefits are mostly a result of exercising dogs. It follows that we shouldn't expect the same improvements with our less social and less active octo-nippled-friend. 
    </p>
    <p>
      On a positive note, and despite the dog-ownership-health-benefit-relationship, we (cat owners) still report lower stress, happier times and more smiles-per-month (I'm making this up but you get the point).
      I fully plan on adopting a pooch or two when I have the physical space and guaranteed free time to play with them but until then I'm going to be happier than you (until you get a cat too), and happy twice over when I get a 2nd cat.
    </p>
    <p>
      You can find some definitely-biased links in the references below to back me up on the topic. Our story is that the little guy has been an overwhelmingly positive influence almost without leaving his cat tree.
    </p>
  `,
  relatedPosts: [],
  references: [
    createExternalLink(
      "CDC on the health benefits of pets",
      "https://www.cdc.gov/healthypets/health-benefits/index.html",
    ),
    createExternalLink(
      "RSPCA on the health benefits of pets",
      "https://kb.rspca.org.au/knowledge-base/what-are-the-health-benefits-of-pet-ownership",
    ),
    createExternalLink(
      "Some newspaper riding off Berkeley's coat-tails; on the health benefits of cats",
      "https://greatergood.berkeley.edu/article/item/the_science_backed_benefits_of_being_a_cat_lover",
    ),
  ],
  ads: [],
})
